<template>
  <v-container fluid class="pa-4">
    <v-overlay
      :model-value="isLoading"
      class="align-center justify-center"
    >
      <v-progress-circular
        color="primary"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-card class="rounded-lg">
      <v-card-title class="d-flex justify-space-between align-center pa-4">
        <div class="d-flex align-center empContractSheetTitle">
          <v-icon color="primary" class="mr-2">mdi-file</v-icon>
          <h2 class="font-weight-bold">임금메이커</h2>
          <b style="width:30px;"> </b>
          <div style="display: inline">
            <v-btn style="border-radius: 5px; margin-right: 5px" :color="wageVersion === 1 ? '#1325c6' : 'white'"
              :class="wageVersion === 1 ? 'text-white' : 'text-black border'" @click="setWageDateVersion(1)">
              기본
            </v-btn>
            <v-btn style="border-radius: 5px" :color="wageVersion === 2 ? '#1325c6' : 'white'"
              :class="wageVersion === 2 ? 'text-white' : 'text-black border'" @click="setWageDateVersion(2)">
              주주야야비비
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-sheet class="empContractSheet">
          <div class="contractMainYearWrapper">
            <!-- <div class="contractMainYear">
              <v-select label="연도 기준" v-model="year" :items="yearOptions" @update:modelValue="updateWorkDays"
                hide-details="auto" density="compact" variant="outlined" />
            </div>
            <div class="contractMainYear">
              <v-select label="월 기준" v-model="month" :items="monthOptions" @update:modelValue="updateWorkDays"
                hide-details="auto" density="compact" variant="outlined" />
            </div> -->

            <div class="contractMainYear">
              <v-text-field class="input-right" v-model="timePay" label="시급" type="number" hide-details="auto"
                density="compact" variant="outlined" style="width: 120px;" />
            </div>

            <div class="contractMainYear">
              <v-text-field class="input-right" v-model="basicWorkTime" label="기본근로(h)" type="number"
                hide-details="auto" density="compact" variant="outlined" style="width: 110px;" />
            </div>

            <div class="contractMainYear">
              <v-text-field class="input-right" v-model="overWorkTime" label="연장근로(h)" type="number" hide-details="auto"
                density="compact" variant="outlined" style="width: 110px;" />
            </div>

            <div class="contractMainYear" v-if="wageVersion === 1">
              <v-text-field class="input-right" v-model="overWorkDaysPercent" label="연장근로(d)" type="number"
                hide-details="auto" density="compact" variant="outlined" style="width: 110px;" />
            </div>

            <div class="contractMainYear">
              <v-text-field class="input-right" v-model="nightWorkTime" label="야간근로(h)" type="number"
                hide-details="auto" density="compact" variant="outlined" style="width: 110px;" />
            </div>

            <div class="contractMainYear" v-if="wageVersion === 1">
              <v-text-field class="input-right" v-model="nightWorkDaysPercent" label="야간근로(d)" type="number"
                hide-details="auto" density="compact" variant="outlined" style="width: 110px;" />
            </div>
          </div>

          <div class="contractMainYearWrapper" style="margin: 12px 0;">
            <div class="contractMainYear">
              <v-text-field class="input-right" v-model="lunchPay" label="중식대" type="number" hide-details="auto"
                density="compact" variant="outlined" style="width: 120px;" />
            </div>
            <div class="contractMainYear">
              <v-text-field class="input-right" v-model="carPay" label="차량비" type="number" hide-details="auto"
                density="compact" variant="outlined" style="width: 120px;" />
            </div>
            <div class="contractMainYear">
              <v-text-field class="input-right" v-model="childPay" label="양육비" type="number" hide-details="auto"
                density="compact" variant="outlined" style="width: 120px;" />
            </div>

            <div class="contractMainYear">
              <v-text-field class="input-right" v-model="bojonPay" label="보존수당" type="number" hide-details="auto"
                density="compact" variant="outlined" style="width: 120px;" />
            </div>
            <div class="contractMainYear">
              <v-text-field class="input-right" v-model="dangPay" label="당직수당" type="number" hide-details="auto"
                density="compact" variant="outlined" style="width: 120px;" />
            </div>
          </div>



          <table class="workCalcTable_empContract text-center">
            <thead>
              <tr>
                <th rowspan="2">구분</th>
                <th colspan="6" v-if="wageVersion === 1">일수</th>
                <th colspan="5" v-if="wageVersion === 2">일수</th>
                <th colspan="3">근로시간</th>
                <th colspan="9">급여</th>
              </tr>
              <tr>
                <th>월간</th>
                <th v-if="wageVersion === 1">근로</th>
                <th v-if="wageVersion === 1">토</th>
                <th v-if="wageVersion === 1">일</th>
                <th v-if="wageVersion === 1">소계</th>
                <th v-if="wageVersion === 1">공휴일</th>
                <th v-if="wageVersion === 2">주간</th>
                <th v-if="wageVersion === 2">야간</th>
                <th v-if="wageVersion === 2">비번</th>
                <th v-if="wageVersion === 2">주휴일</th>
                <th>기본({{ basicWorkTime || 0 }}h)</th>
                <th>연장({{ overWorkTime || 0 }}h)</th>
                <th>야간({{ nightWorkTime || 0 }}h)</th>
                <th>기본급</th>
                <th>연장수당</th>
                <th>야간수당</th>
                <th>보존수당</th>
                <th>당직수당</th>
                <th>중식대</th>
                <th>차랑비</th>
                <th>양육비</th>
                <th>급여총액</th>
                <th v-if="openMonthDataStatus && wageVersion === 1" @click="openMonthDataToggle" class="cursorPointer">
                  닫기↑
                </th>
                <th v-else-if="!openMonthDataStatus && wageVersion === 1" @click="openMonthDataToggle"
                  class="cursorPointer">
                  열기↓
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-if="openMonthDataStatus && wageVersion === 1">
                <tr v-for="(row, index) in wageLists" :key="index">
                  <td>{{ row.year }}년 {{ row.month }}월</td>
                  <td>{{ row.totalDays }}</td>
                  <td>{{ row.onlyBlackDays }}</td>
                  <td>{{ row.saturdayCount }}</td>
                  <td>{{ row.sundayCount }}</td>
                  <td>{{ row.saturdayCount + row.sundayCount }}</td>
                  <td>{{ row.holidayCount }}</td>
                  <td>{{ row.basicTimeMonth }}</td>
                  <td>{{ row.overTimeMonth }}</td>
                  <td>{{ row.nightTimeMonth }}</td>
                  <td class="text-right">{{ row.basicPay }}</td>
                  <td class="text-right">{{ row.overPay }}</td>
                  <td class="text-right">{{ row.nightPay }}</td>
                  <td class="text-right">{{ ac(bojonPay) || 0 }}</td>
                  <td class="text-right">{{ ac(dangPay) || 0 }}</td>
                  <td class="text-right">{{ ac(lunchPay) || 0 }}</td>
                  <td class="text-right">{{ ac(carPay) || 0 }}</td>
                  <td class="text-right">{{ ac(childPay) || 0 }}</td>
                  <td class="text-right">{{ row.totalPay }}</td>
                </tr>
              </template>

              <tr class="empContractSumResultsTr">
                <td>{{ sumResults.month }}</td>
                <td>{{ sumResults.totalDays }}</td>

                <td v-if="wageVersion === 1">{{ sumResults.onlyBlackDays }}</td>
                <td v-if="wageVersion === 1">{{ sumResults.saturdayCount }}</td>
                <td v-if="wageVersion === 1">{{ sumResults.sundayCount }}</td>
                <td v-if="wageVersion === 1">{{ sumResults.weekendCount }}</td>
                <td v-if="wageVersion === 1">{{ sumResults.holidayCount }}</td>

                <td v-if="wageVersion === 2">{{ sumResults.juganDays }}</td>
                <td v-if="wageVersion === 2">{{ sumResults.yaganDays }}</td>
                <td v-if="wageVersion === 2">{{ sumResults.bibunDays }}</td>
                <td v-if="wageVersion === 2">{{ sumResults.juhyuDays }}</td>

                <td>{{ sumResults.basicTimeMonth }}</td>
                <td>{{ sumResults.overTimeMonth }}</td>
                <td>{{ sumResults.nightTimeMonth }}</td>
                <td class="text-right">{{ sumResults.basicPay }}</td>
                <td class="text-right">{{ sumResults.overPay }}</td>
                <td class="text-right">{{ sumResults.nightPay }}</td>
                <td class="text-right">{{ ac(bojonPay * 12) || 0 }}</td>
                <td class="text-right">{{ ac(dangPay * 12) || 0 }}</td>
                <td class="text-right">{{ ac(lunchPay * 12) || 0 }}</td>
                <td class="text-right">{{ ac(carPay * 12) || 0 }}</td>
                <td class="text-right">{{ ac(childPay * 12) || 0 }}</td>
                <td class="text-right">{{ sumResults.totalPay }}</td>
              </tr>

              <tr class="empContractAvgResultsTr">
                <td>{{ avgResults.month }}</td>
                <td>{{ avgResults.totalDays }}</td>

                <td v-if="wageVersion === 1">{{ avgResults.onlyBlackDays }}</td>
                <td v-if="wageVersion === 1">{{ avgResults.saturdayCount }}</td>
                <td v-if="wageVersion === 1">{{ avgResults.sundayCount }}</td>
                <td v-if="wageVersion === 1">{{ avgResults.weekendCount }}</td>
                <td v-if="wageVersion === 1">{{ avgResults.holidayCount }}</td>

                <td v-if="wageVersion === 2">{{ avgResults.juganDays }}</td>
                <td v-if="wageVersion === 2">{{ avgResults.yaganDays }}</td>
                <td v-if="wageVersion === 2">{{ avgResults.bibunDays }}</td>
                <td v-if="wageVersion === 2">{{ avgResults.juhyuDays }}</td>


                <td>{{ avgResults.basicTimeMonth }}</td>
                <td>{{ avgResults.overTimeMonth }}</td>
                <td>{{ avgResults.nightTimeMonth }}</td>
                <td class="text-right">{{ avgResults.basicPay }}</td>
                <td class="text-right">{{ avgResults.overPay }}</td>
                <td class="text-right">{{ avgResults.nightPay }}</td>
                <td class="text-right">{{ ac(bojonPay) || 0 }}</td>
                <td class="text-right">{{ ac(dangPay) || 0 }}</td>
                <td class="text-right">{{ ac(lunchPay) || 0 }}</td>
                <td class="text-right">{{ ac(carPay) || 0 }}</td>
                <td class="text-right">{{ ac(childPay) || 0 }}</td>
                <td class="text-right">{{ avgResults.totalPay }}</td>
              </tr>
            </tbody>
          </table>



        </v-sheet>
      </v-card-text>
    </v-card>
    <v-card class="rounded-lg">
      <v-card-title class="d-flex justify-space-between align-center pa-4">
        <div class="d-flex align-center empContractSheetTitle">
          <v-icon color="primary" class="mr-2">mdi-file</v-icon>
          <h2 class="font-weight-bold">임금계약표</h2>
          <b style="width:30px;"> </b>

          <span>기준:</span><b class="empContractSheetDate">{{ refYearMonth }}</b>
        </div>
      </v-card-title>
      <v-card-text>
        <v-sheet class="empContractSheet">
          <div class="empListCtrlBtn_empContract mt-2 mb-4">
            <v-btn 
              @click="dialog = true" 
              color="grey-darken-1" 
              variant="flat" 
              prepend-icon="mdi-filter-variant" 
              class="mr-2"
              size="small"
              :disabled="isLoading"
            >
              조건검색
            </v-btn>
            <v-btn 
              @click="saveEmpWageContract" 
              color="primary" 
              variant="elevated" 
              prepend-icon="mdi-content-save" 
              class="mr-2"
              size="small"
              :disabled="isLoading"
            >
              저장하기
            </v-btn>
            <v-btn 
              @click="wageInput" 
              color="success" 
              variant="flat" 
              prepend-icon="mdi-download" 
              class="mr-2"
              size="small"
              :disabled="isLoading"
            >
              임금가져오기
            </v-btn>
            <v-btn 
              @click="wageOutput" 
              color="info" 
              variant="flat" 
              prepend-icon="mdi-upload" 
              class="mr-2"
              size="small"
              :disabled="isLoading"
            >
              임금내보내기
            </v-btn>
            <v-btn 
              @click="openBatchEditModal" 
              color="deep-purple" 
              variant="flat" 
              prepend-icon="mdi-content-copy" 
              size="small"
              :disabled="isLoading"
            >
              일괄 변경
            </v-btn>
          </div>
          <table class="text-center empListTable_empContract">
            <thead>
              <tr>
                <th class="empCtCheckTd" rowspan="2">
                  <input type="checkbox" v-model="selectAll" @change="toggleAll" :disabled="isLoading" />
                </th>
                <th rowspan="2">번호</th>
                <th colspan="2">사원</th>
                <th colspan="2">계약시점</th>
                <th colspan="3">근로시간</th>
                <th colspan="10">급여</th>
                <th rowspan="2">임금타입</th>
              </tr>
              <tr>
                <th>이름</th>
                <th>직종</th>
                <th>연도</th>
                <th>월</th>
                <th>기본</th>
                <th>연장</th>
                <th>야간</th>
                <th>시급</th>
                <th>기본급</th>
                <th>연장수당</th>
                <th>야간수당</th>
                <th>보존수당</th>
                <th>당직수당</th>
                <th>중식대</th>
                <th>차랑비</th>
                <th>양육비</th>
                <th>급여총액</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in filteredList" :key="index" class="empContractListTr"
                :class="{ 'selectedRowBgColorChanger': row.checked }">
                <td class="empCtCheckTd">
                  <input type="checkbox" v-model="row.checked" :disabled="isLoading" />
                </td>
                <td class="empCtNumTd pd26">{{ index + 1 }}</td>
                <td class="empCtTd pd26">
                  {{ row.emp_name }}
                  <v-chip 
                    v-if="row.emp_status === '1' || row.emp_status === 1" 
                    size="x-small" 
                    color="success" 
                    class="ml-1"
                  >
                    활성
                  </v-chip>
                  <v-chip 
                    v-else 
                    size="x-small" 
                    color="error" 
                    class="ml-1"
                  >
                    비활성
                  </v-chip>
                </td>
                <td class="empCtTd pd26">{{ row.emp_job }}</td>
                <td class="empCtTd pd26">{{ row.emp_in_year || "" }}</td>
                <td class="empCtTd pd26">{{ row.emp_in_month || "" }}</td>

                <td class="empCtDayInputTd">
                  <input v-model="row.ct_basic_work_time_month" type="text"
                    @focus="clearFormat(row, 'ct_basic_work_time_month')"
                    @blur="applyFormat(row, 'ct_basic_work_time_month')" :ref="el => setInputRef(index, 0, el)"
                    @keydown.down.prevent="focusNextRow(index, 0)" @keydown.up.prevent="focusPrevRow(index, 0)"
                    @keydown.left.prevent="focusLeftCol(index, 0)" @keydown.right.prevent="focusRightCol(index, 0)"
                    :disabled="isLoading" />
                </td>

                <td class="empCtDayInputTd">
                  <input v-model="row.ct_over_work_time_month" type="text"
                    @focus="clearFormat(row, 'ct_over_work_time_month')"
                    @blur="applyFormat(row, 'ct_over_work_time_month')" :ref="el => setInputRef(index, 1, el)"
                    @keydown.down.prevent="focusNextRow(index, 1)" @keydown.up.prevent="focusPrevRow(index, 1)"
                    @keydown.left.prevent="focusLeftCol(index, 1)" @keydown.right.prevent="focusRightCol(index, 1)" />
                </td>

                <td class="empCtDayInputTd">
                  <input v-model="row.ct_night_work_time_month" type="text"
                    @focus="clearFormat(row, 'ct_night_work_time_month')"
                    @blur="applyFormat(row, 'ct_night_work_time_month')" :ref="el => setInputRef(index, 2, el)"
                    @keydown.down.prevent="focusNextRow(index, 2)" @keydown.up.prevent="focusPrevRow(index, 2)"
                    @keydown.left.prevent="focusLeftCol(index, 2)" @keydown.right.prevent="focusRightCol(index, 2)" />
                </td>

                <td class="empCtTimePayInputTd">
                  <input v-model="row.ct_time_pay" type="text" @focus="clearFormat(row, 'ct_time_pay')"
                    @blur="applyFormat(row, 'ct_time_pay')" :ref="el => setInputRef(index, 3, el)"
                    @keydown.down.prevent="focusNextRow(index, 3)" @keydown.up.prevent="focusPrevRow(index, 3)"
                    @keydown.left.prevent="focusLeftCol(index, 3)" @keydown.right.prevent="focusRightCol(index, 3)" />
                </td>

                <td class="empCtMoneyInputTd">
                  <input v-model="row.ct_basic_pay" type="text" @focus="clearFormat(row, 'ct_basic_pay')"
                    @blur="applyFormat(row, 'ct_basic_pay')" :ref="el => setInputRef(index, 4, el)"
                    @keydown.down.prevent="focusNextRow(index, 4)" @keydown.up.prevent="focusPrevRow(index, 4)"
                    @keydown.left.prevent="focusLeftCol(index, 4)" @keydown.right.prevent="focusRightCol(index, 4)" />
                </td>

                <td class="empCtMoneyInputTd">
                  <input v-model="row.ct_over_pay" type="text" @focus="clearFormat(row, 'ct_over_pay')"
                    @blur="applyFormat(row, 'ct_over_pay')" :ref="el => setInputRef(index, 5, el)"
                    @keydown.down.prevent="focusNextRow(index, 5)" @keydown.up.prevent="focusPrevRow(index, 5)"
                    @keydown.left.prevent="focusLeftCol(index, 5)" @keydown.right.prevent="focusRightCol(index, 5)" />
                </td>

                <td class="empCtMoneyInputTd">
                  <input v-model="row.ct_night_pay" type="text" @focus="clearFormat(row, 'ct_night_pay')"
                    @blur="applyFormat(row, 'ct_night_pay')" :ref="el => setInputRef(index, 6, el)"
                    @keydown.down.prevent="focusNextRow(index, 6)" @keydown.up.prevent="focusPrevRow(index, 6)"
                    @keydown.left.prevent="focusLeftCol(index, 6)" @keydown.right.prevent="focusRightCol(index, 6)" />
                </td>

                <td class="empCtMoneyInputTd">
                  <input v-model="row.ct_bojon_pay" type="text" @focus="clearFormat(row, 'ct_bojon_pay')"
                    @blur="applyFormat(row, 'ct_bojon_pay')" :ref="el => setInputRef(index, 7, el)"
                    @keydown.down.prevent="focusNextRow(index, 7)" @keydown.up.prevent="focusPrevRow(index, 7)"
                    @keydown.left.prevent="focusLeftCol(index, 7)" @keydown.right.prevent="focusRightCol(index, 7)" />
                </td>
                <td class="empCtMoneyInputTd">
                  <input v-model="row.ct_dang_pay" type="text" @focus="clearFormat(row, 'ct_dang_pay')"
                    @blur="applyFormat(row, 'ct_dang_pay')" :ref="el => setInputRef(index, 7, el)"
                    @keydown.down.prevent="focusNextRow(index, 7)" @keydown.up.prevent="focusPrevRow(index, 7)"
                    @keydown.left.prevent="focusLeftCol(index, 7)" @keydown.right.prevent="focusRightCol(index, 7)" />
                </td>
                <td class="empCtMoneyInputTd">
                  <input v-model="row.ct_lunch_pay" type="text" @focus="clearFormat(row, 'ct_lunch_pay')"
                    @blur="applyFormat(row, 'ct_lunch_pay')" :ref="el => setInputRef(index, 8, el)"
                    @keydown.down.prevent="focusNextRow(index, 8)" @keydown.up.prevent="focusPrevRow(index, 8)"
                    @keydown.left.prevent="focusLeftCol(index, 8)" @keydown.right.prevent="focusRightCol(index, 8)" />
                </td>
                <td class="empCtMoneyInputTd">
                  <input v-model="row.ct_car_pay" type="text" @focus="clearFormat(row, 'ct_car_pay')"
                    @blur="applyFormat(row, 'ct_car_pay')" :ref="el => setInputRef(index, 9, el)"
                    @keydown.down.prevent="focusNextRow(index, 9)" @keydown.up.prevent="focusPrevRow(index, 9)"
                    @keydown.left.prevent="focusLeftCol(index, 9)" @keydown.right.prevent="focusRightCol(index, 9)" />
                </td>
                <td class="empCtMoneyInputTd">
                  <input v-model="row.ct_child_pay" type="text" @focus="clearFormat(row, 'ct_child_pay')"
                    @blur="applyFormat(row, 'ct_child_pay')" :ref="el => setInputRef(index, 10, el)"
                    @keydown.down.prevent="focusNextRow(index, 10)" @keydown.up.prevent="focusPrevRow(index, 10)"
                    @keydown.left.prevent="focusLeftCol(index, 10)" @keydown.right.prevent="focusRightCol(index, 10)" />
                </td>
                <td class="empCtMoneyTd pd26">{{ totalPay(row) || 0 }}</td>
                <td class="empCtTd pd26">{{ row.ct_wage_type }}</td>
                <td @click="deleteEmpContract(row.ct_idx)" style="cursor: pointer;">삭제</td>
              </tr>
            </tbody>
          </table>
        </v-sheet>
        <div style="height: 80px"></div>
      </v-card-text>
    </v-card>
  </v-container>



  <v-dialog v-model="dialog" max-width="500">
    <v-card class="rounded-lg">
      <v-card-title class="text-h5 font-weight-bold primary pa-4 text-white d-flex align-center">
        <v-icon class="mr-2" color="white">mdi-filter-variant</v-icon>
        임금계약표 조건검색
      </v-card-title>
      <v-card-text class="pa-6">
        <v-alert
          density="compact"
          type="info"
          variant="tonal"
          class="mb-4"
          icon="mdi-information"
        >
          임금계약 유형과 사원 상태를 선택하여 필터링합니다.
        </v-alert>
        
        <v-row class="mt-2">
          <v-col cols="12">
            <h3 class="text-subtitle-1 font-weight-bold d-flex align-center mb-3">
              <v-icon size="small" color="primary" class="mr-2">mdi-tag-multiple</v-icon>
              임금계약 유형
            </h3>
            <v-checkbox v-model="selectedType" label="기본" value="기본" color="primary" hide-details class="mb-2" @change="filterList" />
            <v-checkbox v-model="selectedType" label="주주야야비비" value="주주야야비비" color="primary" hide-details class="mb-2" @change="filterList" />
            <v-checkbox v-model="selectedType" label="없음" value="" color="primary" hide-details @change="filterList" />
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <v-row class="mt-2">
          <v-col cols="12">
            <h3 class="text-subtitle-1 font-weight-bold d-flex align-center mb-3">
              <v-icon size="small" color="primary" class="mr-2">mdi-account-check</v-icon>
              사원 상태
            </h3>
            <v-checkbox v-model="selectedStatus" label="활성 사원" value="1" color="primary" hide-details class="mb-2" @change="filterList" />
            <v-checkbox v-model="selectedStatus" label="비활성(퇴사) 사원" value="0" color="primary" hide-details @change="filterList" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-4 bg-grey-lighten-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="flat" prepend-icon="mdi-check" @click="dialog = false">
          확인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="batchEditDialog" max-width="600">
    <v-card class="rounded-lg">
      <v-card-title>
        <h2>일괄 변경</h2>
      </v-card-title>
      <v-card-text class="pa-6">
        <v-alert
          density="compact"
          type="info"
          variant="tonal"
          class="mb-4"
          icon="mdi-information"
        >
          체크한 사원들의 임금계약 정보를 일괄 변경합니다.
        </v-alert>
        
        <v-row>
          <v-col cols="12">
            <h3>
              <v-icon size="small" color="primary" class="mr-2">mdi-format-list-checks</v-icon>
              변경할 항목
            </h3>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="batchFields" label="시급" value="ct_time_pay" hide-details color="primary" class="my-0 py-1" density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="batchFields" label="기본 근로시간" value="ct_basic_work_time_month" hide-details color="primary" class="my-0 py-1" density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="batchFields" label="연장 근로시간" value="ct_over_work_time_month" hide-details color="primary" class="my-0 py-1" density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="batchFields" label="야간 근로시간" value="ct_night_work_time_month" hide-details color="primary" class="my-0 py-1" density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="batchFields" label="기본급" value="ct_basic_pay" hide-details color="primary" class="my-0 py-1" density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="batchFields" label="연장수당" value="ct_over_pay" hide-details color="primary" class="my-0 py-1" density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="batchFields" label="야간수당" value="ct_night_pay" hide-details color="primary" class="my-0 py-1" density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="batchFields" label="보존수당" value="ct_bojon_pay" hide-details color="primary" class="my-0 py-1" density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="batchFields" label="당직수당" value="ct_dang_pay" hide-details color="primary" class="my-0 py-1" density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="batchFields" label="중식대" value="ct_lunch_pay" hide-details color="primary" class="my-0 py-1" density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="batchFields" label="차량비" value="ct_car_pay" hide-details color="primary" class="my-0 py-1" density="compact" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-checkbox v-model="batchFields" label="양육비" value="ct_child_pay" hide-details color="primary" class="my-0 py-1" density="compact" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <v-row class="mt-4">
          <v-col cols="12">
            <h3>
              <v-icon size="small" color="primary" class="mr-2">mdi-cog-outline</v-icon>
              변경 방식
            </h3>
            <v-radio-group v-model="batchEditType" inline>
              <v-radio color="primary" value="absolute" label="직접 입력 값으로 변경" />
              <v-radio color="primary" value="amount" label="금액 증감" />
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row class="mt-2">
          <v-col cols="12">
            <v-text-field
              v-model="batchEditValue"
              :label="batchEditType === 'absolute' ? '변경할 값' : '증감 금액'"
              type="number"
              :hint="batchEditType === 'amount' ? '예: 10000 → 10,000원 증가, -10000 → 10,000원 감소' : ''"
              persistent-hint
              variant="outlined"
              color="primary"
              density="compact"
              :prefix="batchEditType === 'amount' && batchEditValue && batchEditValue > 0 ? '+' : ''"
              hide-details="auto"
            >
              <template v-slot:prepend>
                <v-icon color="primary">{{ batchEditType === 'absolute' ? 'mdi-currency-krw' : 'mdi-math-compass' }}</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

      </v-card-text>
      <v-card-actions class="pa-4 bg-grey-lighten-4">
        <v-chip
          v-if="batchFields.length > 0"
          color="primary"
          size="small"
          class="mr-2"
        >
          {{ batchFields.length }}개 항목 선택됨
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn color="grey-darken-1" variant="text" prepend-icon="mdi-close" @click="batchEditDialog = false">
          취소
        </v-btn>
        <v-btn 
          color="primary" 
          variant="elevated" 
          prepend-icon="mdi-check" 
          class="ml-2" 
          :disabled="batchFields.length === 0 || batchEditValue === null"
          @click="applyBatchEdit"
        >
          적용
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>
<script setup lang="ts">
/* eslint-disable */
import axios from "axios";
import { ref, watch, onMounted, computed } from "vue";
import store from "@/store";

interface Employee {
  checked?: boolean;
  emp_name: string;
  emp_job: string;
  ct_start_year?: string;
  ct_start_month?: string;
  ct_basic_work_time_month?: string | number;
  ct_over_work_time_month?: string | number;
  ct_night_work_time_month?: string | number;
  ct_time_pay?: string | number;
  ct_basic_pay?: string | number;
  ct_over_pay?: string | number;
  ct_night_pay?: string | number;
  ct_bojon_pay?: string | number;
  ct_lunch_pay?: string | number;
  ct_car_pay?: string | number;
  ct_child_pay?: string | number;
  ct_dang_pay?: string | number;
  ct_total_pay?: string | number;
  ct_wage_type?: string;
  // eslint-disable-next-line
  [key: string]: any;
}

const sisulCode = computed(() => store.state.AdminSisulCode);

const endYear = ref(0);
const endMonth = ref(0);
const year = ref(0);
const month = ref(1);
const timePay = ref(0);
const basicWorkTime = ref(8);
const overWorkTime = ref(1);
const overWorkDaysPercent = ref(50);
const nightWorkTime = ref(4.5) || 0;
const nightWorkDaysPercent = ref(50);

const wageVersion = ref(1);

//교대인 경우, 주간:야간 비율로 연장근로

const selectAll = ref(false);
const dialog = ref(false);
const batchEditDialog = ref(false);
const batchFields = ref<string[]>([]);
const batchEditType = ref('absolute');
const batchEditValue = ref<number | null>(null);
const isLoading = ref(false); // 로딩 상태 추가

const selectedType = ref<string[]>(['기본', '주주야야비비', '']); // 체크박스용 배열
const selectedStatus = ref<string[]>(['0', '1']); // emp_status 필터링용 배열 추가
const filteredList = ref<any[]>([]);
const inputRefs = ref([]) as any;


// eslint-disable-next-line
const yearOptions = ref([]) as any;
// eslint-disable-next-line
const monthOptions = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]) as any;
// eslint-disable-next-line
const wageLists = ref([]) as any;
// eslint-disable-next-line
const bojonPay = ref(0) as any;
// eslint-disable-next-line
const dangPay = ref(0) as any;
// eslint-disable-next-line
const lunchPay = ref(0) as any;
// eslint-disable-next-line
const carPay = ref(0) as any;
// eslint-disable-next-line
const childPay = ref(0) as any;
// eslint-disable-next-line

const refYearMonth = ref(null) as any;
// eslint-disable-next-line
const empList = ref<Employee[]>([]) as any;
// eslint-disable-next-line
const holidays = ref([]) as any;
// eslint-disable-next-line
const sumResults = ref([]) as any;
// eslint-disable-next-line
const avgResults = ref([]) as any;


const filterList = async () => {
  isLoading.value = true;
  try {
    await getEmpContractInfo();
    if (selectedType.value.length === 0 && selectedStatus.value.length === 0) {
      filteredList.value = empList.value;
    } else {
      filteredList.value = empList.value.filter((emp: any) => {
        const type = emp.ct_wage_type ?? ''; // null → ''
        const status = emp.emp_status?.toString() ?? '0'; // emp_status를 문자열로 변환
        
        const typeMatch = selectedType.value.length === 0 || selectedType.value.includes(type);
        const statusMatch = selectedStatus.value.length === 0 || selectedStatus.value.includes(status);
        
        return typeMatch && statusMatch;
      });
    }
  } finally {
    isLoading.value = false;
  }
};

// input 참조 저장
const setInputRef = (row: any, col: any, el: any) => {
  if (!inputRefs.value[row]) inputRefs.value[row] = []
  inputRefs.value[row][col] = el
}

// ↓ 방향키
const focusNextRow = (row: any, col: any) => {
  const nextRow = inputRefs.value[row + 1]
  if (nextRow && nextRow[col]) {
    nextRow[col].focus()
  }
}

// ↑ 방향키
const focusPrevRow = (row: any, col: any) => {
  const prevRow = inputRefs.value[row - 1]
  if (prevRow && prevRow[col]) {
    prevRow[col].focus()
  }
}
// ← 방향키
const focusLeftCol = (row: any, col: any) => {
  const prevCol = inputRefs.value[row]?.[col - 1]
  if (prevCol) {
    prevCol.focus()
  }
}

// → 방향키
const focusRightCol = (row: any, col: any) => {
  const nextCol = inputRefs.value[row]?.[col + 1]
  if (nextCol) {
    nextCol.focus()
  }
}
function setWageDateVersion(version: number) {
  wageVersion.value = version;
  openMonthDataStatus.value = false;
}
const openMonthDataStatus = ref(false);
const openMonthDataToggle = () => {
  openMonthDataStatus.value = !openMonthDataStatus.value;
};


const toggleAll = () => {
  const isAllChecked = empList.value.every((row: { checked: any }) => row.checked);
  selectAll.value = !isAllChecked;
  empList.value.forEach((row: { checked: any }) => {
    row.checked = selectAll.value;
  });
};

// 개별 체크박스가 변경될 때 전체 선택 상태 업데이트
watch(
  empList,
  (newVal) => {
    selectAll.value = newVal.every((row: { checked: any }) => row.checked);
  },
  { deep: true }
);

function clearFormat(item: any, key: any) {
  // 인풋의 값을 컴마 없이 만듭니다.
  item[key] = nc(item[key]);

  // 값이 0이면 빈 값으로 설정하여 placeholder를 보이도록 합니다.
  if (!item[key] || item[key] === "0" || item[key] === 0 || item[key] === "-0") {
    item[key] = "";
  }
}

function applyFormat(item: any, key: any) {
  // 값이 비어있으면 0으로 설정
  if (
    item[key] === "" ||
    item[key] === null ||
    item[key] === undefined ||
    item[key] === "-0"
  ) {
    item[key] = '';
  } else {
    // 포커스가 해제되면 천 단위로 컴마를 추가
    item[key] = formatNumber(item[key]);
  }
}

function formatNumber(value: any): string {
  // 숫자인지 확인하고 천 단위로 컴마 추가
  const number = parseFloat(value);
  if (!isNaN(number)) {
    return number.toLocaleString();
  }
  return value;
}

function ac(number: any) {
  const num = Number(number);
  if (isNaN(num)) return number;
  if (num === 0) return '';
  return num.toLocaleString();
}
function nc(value: any) {
  if (value == null) {
    return 0;
  }
  return parseFloat(value.toString().replace(/,/g, ""));
}
const totalPay = (row: any) => {
  let calc = 0
  calc =
    nc(row.ct_basic_pay || 0) + nc(row.ct_over_pay || 0) + nc(row.ct_night_pay || 0) + nc(row.ct_bojon_pay || 0) +
    nc(row.ct_lunch_pay || 0) + nc(row.ct_car_pay || 0) + nc(row.ct_child_pay || 0) + nc(row.ct_dang_pay || 0);
  row.ct_total_pay = ac(calc);
  return row.ct_total_pay;
};

const wageInput = async () => {
  // 가져오기
  const checkedRows = empList.value.filter((row: { checked: any }) => row.checked);

  if (checkedRows.length === 0) {
    alert("사원을 체크해주세요.");
    return;
  }

  const isConfirmed = window.confirm(
    "임금메이커에서 임금데이터를 [ 가져오기 ] 하시겠습니까?"
  );

  if (isConfirmed) {
    let wageType = '';
    if (wageVersion.value === 1) {
      wageType = '기본'
    } else if (wageVersion.value === 2) {
      wageType = '주주야야비비'
    }
    
    // 체크된 직원들만 데이터 업데이트
    empList.value = empList.value.map((row: { checked: any }) => {
      if (row.checked) {
        return {
          ...row,
          ct_start_year: year.value,
          ct_start_month: month.value,
          ct_end_year: endYear.value,
          ct_end_month: endMonth.value,
          ct_time_pay: ac(timePay.value),
          ct_basic_work_time: basicWorkTime.value,
          ct_over_work_time: overWorkTime.value,
          ct_night_work_time: nightWorkTime.value,
          ct_over_work_days_percent: overWorkDaysPercent.value,
          ct_night_work_days_percent: nightWorkDaysPercent.value,
          
          ct_basic_work_time_month: avgResults.value.basicTimeMonth,
          ct_over_work_time_month: avgResults.value.overTimeMonth,
          ct_night_work_time_month: avgResults.value.nightTimeMonth,
          
          ct_basic_pay: avgResults.value.basicPay,
          ct_over_pay: avgResults.value.overPay,
          ct_night_pay: avgResults.value.nightPay,
          
          ct_bojon_pay: ac(bojonPay.value),
          ct_dang_pay: ac(dangPay.value),
          ct_lunch_pay: ac(lunchPay.value),
          ct_car_pay: ac(carPay.value),
          ct_child_pay: ac(childPay.value),
          ct_total_pay: avgResults.value.totalPay,
          
          mng_id: store.getters.id,
          sisul_code: store.state.AdminSisulCode,
          ct_wage_type: wageType,
        };
      }
      return row;
    });
    
    try {
      // 체크된 직원들만 API로 저장
      const selectedEmployees = empList.value
        .filter((row: { checked: any }) => row.checked)
        .map((emp: any) => ({
          ...emp,
          ct_lunch_pay: nc(emp.ct_lunch_pay),
          ct_bojon_pay: nc(emp.ct_bojon_pay),
          ct_car_pay: nc(emp.ct_car_pay),
          ct_child_pay: nc(emp.ct_child_pay),
          ct_time_pay: nc(emp.ct_time_pay),
          ct_dang_pay: nc(emp.ct_dang_pay)
        }));
      
      const response = await axios.post("/api/saveEmpWageContract", {
        form: selectedEmployees,
      });
      
      const result = response.data;
      if (!result.success) {
        alert("실패하였습니다. 관리자에게 문의해주세요.");
      }
    } catch (error) {
      alert("처리할 수 없습니다.");
      console.error(error);
    }
    
    // 필터링된 목록 업데이트
    await filterList();
  }
};

const wageOutput = async () => {
  // 임금내보내기
  const checkedRows = empList.value.filter((row: { checked: any }) => row.checked);

  // 체크된 항목이 1개 초과인 경우 경고 메시지 출력
  if (checkedRows.length > 1) {
    alert("하나만 체크해주세요.");
    return; // 1개 초과일 경우 함수 종료
  }
  if (checkedRows.length === 1) {
    const isConfirmed = window.confirm(
      "체크된 사원의 임금데이터를 임금메이커로 [ 내보내기 ] 하시겠습니까?"
    );
    if (isConfirmed) {
      const selectedRow = checkedRows[0];

      year.value = selectedRow.ct_start_year;
      month.value = selectedRow.ct_start_month;
      timePay.value = nc(selectedRow.ct_time_pay) || 0;
      basicWorkTime.value = selectedRow.ct_basic_work_time;
      overWorkTime.value = selectedRow.ct_over_work_time;
      nightWorkTime.value = selectedRow.ct_night_work_time;
      overWorkDaysPercent.value = selectedRow.ct_over_work_days_percent;
      nightWorkDaysPercent.value = selectedRow.ct_night_work_days_percent;
      bojonPay.value = nc(selectedRow.ct_bojon_pay) || 0;
      dangPay.value = nc(selectedRow.ct_dang_pay) || 0;
      lunchPay.value = nc(selectedRow.ct_lunch_pay) || 0;
      carPay.value = nc(selectedRow.ct_car_pay) || 0;
      childPay.value = nc(selectedRow.ct_child_pay) || 0;
      if (selectedRow.ct_wage_type === '기본') {
        wageVersion.value = 1;
      } else if (selectedRow.ct_wage_type === '주주야야비비') {
        wageVersion.value = 2;
      }
  await filterList();

    }

  } else {
    alert("체크된 사원이 없습니다.");
  }
};

const updateWorkDays = async () => {
  await getMonthHolidays();
  let allWorkDays = getWorkDays(year.value, month.value);
  if (year.value >= 2025) {
    timePay.value = 10030;
  } else {
    timePay.value = 9860;
  }
  // 순서대로 합치기
  wageLists.value = allWorkDays;
  console.log(wageLists.value, 'wageLists.value')
};

const updatePays = async () => {
  let allWorkDays = getWorkDays(year.value, month.value);
  wageLists.value = allWorkDays;
};

watch(year, updateWorkDays);
watch(month, updateWorkDays);
watch(timePay, updatePays);
watch(basicWorkTime, updatePays);
watch(overWorkTime, updatePays);
watch(nightWorkTime, updatePays);
watch(overWorkDaysPercent, updatePays);
watch(nightWorkDaysPercent, updatePays);
watch(bojonPay, updatePays);
watch(dangPay, updatePays);
watch(lunchPay, updatePays);
watch(carPay, updatePays);
watch(childPay, updatePays);
watch(wageVersion, updatePays);


const getWorkDays = (year: number, month: number) => {
  let results = [];
  let totals = {
    totalDays: 0,
    onlyBlackDays: 0,
    saturdayCount: 0,
    sundayCount: 0,
    holidayCount: 0,
    basicTimeMonth: 0,
    overTimeMonth: 0,
    nightTimeMonth: 0,
    basicPay: 0,
    overPay: 0,
    nightPay: 0,
    totalPay: 0,
  };

  if (wageVersion.value === 1) {

    // 12개월 동안 반복
    for (let i = 0; i < 12; i++) {
      let currentYear = year;
      let currentMonth = month + i;

      // 월이 12를 초과할 경우 연도를 증가시키고, 월을 1월로 리셋
      if (currentMonth > 12) {
        currentYear++;
        currentMonth = currentMonth - 12;
      }

      let totalDays = new Date(currentYear, currentMonth, 0).getDate();
      let firstDayOfWeek = new Date(currentYear, currentMonth - 1, 1).getDay();

      let saturdayCount = 0;
      let sundayCount = 0;
      let holidayCount = 0;

      let weekFullyStarted = true; // 기본적으로 모든 주 포함

      // 1월: 첫 주가 월요일로 시작하지 않으면 토/일 제외
      if (i === 0 && firstDayOfWeek !== 1) {
        weekFullyStarted = false;
      }

      for (let day = 1; day <= totalDays; day++) {
        let date = new Date(currentYear, currentMonth - 1, day);
        let dayOfWeek = date.getDay();
        let formattedDate = `${String(currentMonth).padStart(2, "0")}-${String(
          day
        ).padStart(2, "0")}`;

        // 첫 주 제외 로직
        if (!weekFullyStarted && (dayOfWeek === 6 || dayOfWeek === 0)) {
          continue;
        }

        if (dayOfWeek === 6) saturdayCount++;
        if (dayOfWeek === 0) sundayCount++;
        if (holidays.value.includes(formattedDate)) holidayCount++;

        if (dayOfWeek === 5) {
          weekFullyStarted = true;
        }
      }

      let onlyBlackDays = totalDays - (saturdayCount + sundayCount + holidayCount) || 0; // 근로일 계산

      let basicWorkDays = onlyBlackDays + sundayCount + holidayCount || 0;

      let basicTimeMonth =
        parseFloat((basicWorkDays * basicWorkTime.value).toFixed(2)) || 0;
      let overTimeMonth =
        parseFloat(
          (
            ((onlyBlackDays * overWorkDaysPercent.value) / 100) *
            overWorkTime.value
          ).toFixed(2)
        ) || 0;
      let nightTimeMonth =
        parseFloat(
          (
            ((onlyBlackDays * nightWorkDaysPercent.value) / 100) *
            nightWorkTime.value
          ).toFixed(2)
        ) || 0;

      let basicPay =
        ac(Math.ceil(basicWorkDays * basicWorkTime.value * timePay.value)) || 0;
      let overPay = ac(Math.ceil(overTimeMonth * timePay.value * 1.5)) || 0;
      let nightPay = ac(Math.ceil(nightTimeMonth * timePay.value * 0.5)) || 0;
      let bojonPay_format = bojonPay.value || 0;
      let dangPay_format = dangPay.value || 0;
      let lunchPay_format = lunchPay.value || 0;
      let carPay_format = carPay.value || 0;
      let childPay_format = childPay.value || 0;
      let totalPay =
        ac(
          nc(basicPay) +
          nc(overPay) +
          nc(nightPay) +
          nc(bojonPay_format) +
          nc(lunchPay_format) +
          nc(carPay_format) +
          nc(childPay_format) +
          nc(dangPay_format)
        ) || 0;

      if (i === 11) {
        endYear.value = currentYear;
        endMonth.value = currentMonth;
      }
      // 해당 월의 결과 저장
      results.push({
        year: currentYear,
        month: currentMonth,
        totalDays,
        onlyBlackDays: onlyBlackDays,
        saturdayCount,
        sundayCount,
        weekendCount: saturdayCount + sundayCount,
        holidayCount,
        basicTimeMonth,
        overTimeMonth,
        nightTimeMonth,
        basicPay,
        overPay,
        nightPay,
        totalPay,
      });

      // 합산
      totals.totalDays += totalDays || 0;
      totals.onlyBlackDays += onlyBlackDays || 0;
      totals.saturdayCount += saturdayCount || 0;
      totals.sundayCount += sundayCount || 0;
      totals.holidayCount += holidayCount || 0;
      totals.basicTimeMonth += basicTimeMonth || 0;
      totals.overTimeMonth += overTimeMonth || 0;
      totals.nightTimeMonth += nightTimeMonth || 0;
    }

    let sumBasicPay = Math.ceil(totals.basicTimeMonth * timePay.value);
    let sumOverPay = Math.ceil(totals.overTimeMonth * timePay.value * 1.5);
    let sumNightPay = Math.ceil(totals.nightTimeMonth * timePay.value * 0.5);

    // 합계 추가
    sumResults.value = {
      month: "합계",
      totalDays: totals.totalDays || 0,
      onlyBlackDays: totals.onlyBlackDays || 0,
      saturdayCount: totals.saturdayCount || 0,
      sundayCount: totals.sundayCount || 0,
      weekendCount: totals.saturdayCount + totals.sundayCount || 0,
      holidayCount: totals.holidayCount || 0,
      basicTimeMonth: totals.basicTimeMonth.toFixed(2) || 0,
      overTimeMonth: totals.overTimeMonth.toFixed(2) || 0,
      nightTimeMonth: totals.nightTimeMonth.toFixed(2) || 0,
      basicPay: ac(sumBasicPay) || 0,
      overPay: ac(sumOverPay) || 0,
      nightPay: ac(sumNightPay) || 0,
      totalPay: ac(nc(sumBasicPay) + nc(sumOverPay) + nc(sumNightPay)) || 0,

    };

    // 평균 추가 (반올림)

    let avgBasicTimeMonth = parseFloat((totals.basicTimeMonth / 12).toFixed(2));
    let avgOverTimeMonth = parseFloat((totals.overTimeMonth / 12).toFixed(2));
    let avgNightTimeMonth = parseFloat((totals.nightTimeMonth / 12).toFixed(2));

    if (avgBasicTimeMonth >= 209.1 && avgBasicTimeMonth <= 209.9) {
      // 209.1~209.9 사이일 경우 소수점 절삭 (내림)
      avgBasicTimeMonth = Math.floor(avgBasicTimeMonth);
    } else if (avgBasicTimeMonth >= 208 && avgBasicTimeMonth <= 208.9) {
      avgBasicTimeMonth = Math.ceil(avgBasicTimeMonth);
    } else {
      // 그 외의 경우는 반올림
      avgBasicTimeMonth = Math.round(avgBasicTimeMonth);
    }
    let avgBasicPay = Math.ceil(avgBasicTimeMonth * timePay.value);
    let avgOverPay = Math.ceil(avgOverTimeMonth * timePay.value * 1.5);
    let avgNightPay = Math.ceil(avgNightTimeMonth * timePay.value * 0.5);

    let bojonPay_format = bojonPay.value || 0;
    let lunchPay_format = lunchPay.value || 0;
    let carPay_format = carPay.value || 0;
    let childPay_format = childPay.value || 0;
    let dangPay_format = dangPay.value || 0;
    avgResults.value = {
      month: "평균",
      totalDays: (totals.totalDays / 12).toFixed(2) || 0,
      onlyBlackDays: (totals.onlyBlackDays / 12).toFixed(2) || 0,
      saturdayCount: (totals.saturdayCount / 12).toFixed(2) || 0,
      sundayCount: (totals.sundayCount / 12).toFixed(2) || 0,
      weekendCount: ((totals.saturdayCount + totals.sundayCount) / 12).toFixed(2) || 0,
      holidayCount: (totals.holidayCount / 12).toFixed(2) || 0,

      basicTimeMonth: avgBasicTimeMonth || 0,
      overTimeMonth: avgOverTimeMonth || 0,
      nightTimeMonth: avgNightTimeMonth || 0,

      basicPay: ac(avgBasicPay) || 0,
      overPay: ac(avgOverPay) || 0,
      nightPay: ac(avgNightPay) || 0,

      totalPay:
        ac(
          avgBasicPay +
          avgOverPay +
          avgNightPay +
          nc(bojonPay_format) +
          nc(lunchPay_format) +
          nc(carPay_format) +
          nc(childPay_format) +
          nc(dangPay_format)
        ) || 0,
    };
  } else if (wageVersion.value === 2) {
    // 합계 추가
    let totalDays = 365;
    let juganDays = parseFloat((totalDays / 3).toFixed(2)) || 0;
    let yaganDays = parseFloat((totalDays / 3).toFixed(2)) || 0;
    let bibunDays = parseFloat((totalDays / 3).toFixed(2)) || 0;
    let juhyuDays = 52;


    let basicWorkDays = juganDays + yaganDays + juhyuDays;
    let basicTimeMonth = basicWorkDays * basicWorkTime.value || 0;

    let overTimeMonth =
      parseFloat(
        (
          juganDays *
          overWorkTime.value
        ).toFixed(2)
      ) || 0;
    let nightTimeMonth =
      parseFloat(
        (
          yaganDays *
          nightWorkTime.value
        ).toFixed(2)
      ) || 0;

    let sumBasicPay = Math.ceil(basicTimeMonth * timePay.value);
    let sumOverPay = Math.ceil(overTimeMonth * timePay.value * 1.5);
    let sumNightPay = Math.ceil(nightTimeMonth * timePay.value * 0.5);

    sumResults.value = {
      month: "합계",
      totalDays: totalDays,
      juganDays: juganDays,
      yaganDays: yaganDays,
      bibunDays: bibunDays,
      juhyuDays: juhyuDays,
      basicTimeMonth: ac(basicTimeMonth) || 0,
      overTimeMonth: ac(overTimeMonth) || 0,
      nightTimeMonth: ac(nightTimeMonth) || 0,
      basicPay: ac(sumBasicPay) || 0,
      overPay: ac(sumOverPay) || 0,
      nightPay: ac(sumNightPay) || 0,
      totalPay: ac(nc(sumBasicPay) + nc(sumOverPay) + nc(sumNightPay)) || 0,
    };

    let totalDaysAvg = (sumResults.value.totalDays / 12).toFixed(2) || 0;
    let juganDaysAvg = parseFloat((sumResults.value.juganDays / 12).toFixed(2)) || 0;
    let yaganDaysAvg = parseFloat((sumResults.value.yaganDays / 12).toFixed(2)) || 0;
    let bibunDaysAvg = parseFloat((sumResults.value.bibunDays / 12).toFixed(2)) || 0;
    let juhyuDaysAvg = parseFloat((sumResults.value.juhyuDays / 12).toFixed(2)) || 0;

    let basicTimeMonthAvg = Math.ceil((juganDaysAvg + yaganDaysAvg + juhyuDaysAvg) * basicWorkTime.value) || 0;
    let overTimeMonthAvg = parseFloat((juganDaysAvg * overWorkTime.value).toFixed(2)) || 0;
    let nightTimeMonthAvg = parseFloat((yaganDaysAvg * nightWorkTime.value).toFixed(2)) || 0;

    let basicPayAvg = basicTimeMonthAvg * timePay.value || 0;
    let overPayAvg = Math.ceil(overTimeMonthAvg * timePay.value * 1.5) || 0;
    let nightPayAvg = Math.ceil(nightTimeMonthAvg * timePay.value * 0.5) || 0;

    avgResults.value = {
      month: "평균",
      totalDays: totalDaysAvg,
      juganDays: juganDaysAvg,
      yaganDays: yaganDaysAvg,
      bibunDays: bibunDaysAvg,
      juhyuDays: juhyuDaysAvg,

      basicTimeMonth: ac(basicTimeMonthAvg),
      overTimeMonth: ac(overTimeMonthAvg),
      nightTimeMonth: ac(nightTimeMonthAvg),

      basicPay: ac(basicPayAvg) || 0,
      overPay: ac(overPayAvg) || 0,
      nightPay: ac(nightPayAvg) || 0,
      totalPay: ac(basicPayAvg + overPayAvg + nightPayAvg) || 0,

    };
  }

  // 수당은 모두 반올림 고정,
  return results;
};

const getYears = async () => {
  isLoading.value = true;
  try {
    const response = await axios.get("/api/getYears");
    if (response.data) {
      yearOptions.value = response.data;
      const currentYear = new Date().getFullYear();
      year.value = currentYear;
    } else {
      console.error("연도 정보를 불러오는 데 실패했습니다.");
    }
  } catch (error) {
    console.error("에러 발생:", error);
  } finally {
    isLoading.value = false;
    await updateWorkDays();
  }
};
const getMonthHolidays = async () => {
  isLoading.value = true;
  try {
    const response = await axios.get(
      `/api/getMonthHolidays/${year.value}/${month.value}`
    );
    if (response.data) {
      holidays.value = response.data;
    } else {
      console.error("공휴일정보를 불러오는 데 실패했습니다.");
    }
  } catch (error) {
    console.error("에러 발생:", error);
  } finally {
    isLoading.value = false;
  }
};
const getEmpContractInfo = async () => {
  isLoading.value = true;
  try {
    const response = await axios.get(
      `/api/getEmpContractInfo/${sisulCode.value}`
    );
    if (response.data) {
      empList.value = response.data.map((emp: any) => ({
        ...emp,
        ct_lunch_pay: ac(emp.ct_lunch_pay),
        ct_bojon_pay: ac(emp.ct_bojon_pay),
        ct_car_pay: ac(emp.ct_car_pay),
        ct_child_pay: ac(emp.ct_child_pay),
        ct_dang_pay: ac(emp.ct_dang_pay),
        ct_time_pay: ac(emp.ct_time_pay)
      }));
    } else {
      console.error("사원정보 불러오기에 실패하였습니다.");
    }
  } catch (error) {
    console.error("에러 발생:", error);
  } finally {
    isLoading.value = false;
  }
};


const saveEmpWageContract = async () => {
  isLoading.value = true;
  try {
    const allEmployees = empList.value.map((emp: any) => ({
      ...emp,
      ct_lunch_pay: nc(emp.ct_lunch_pay),
      ct_bojon_pay: nc(emp.ct_bojon_pay),
      ct_car_pay: nc(emp.ct_car_pay),
      ct_child_pay: nc(emp.ct_child_pay),
      ct_time_pay: nc(emp.ct_time_pay),
      ct_dang_pay: nc(emp.ct_dang_pay)
    }));
    
    const response = await axios.post("/api/saveEmpWageContract", {
      form: allEmployees,
    });
    const result = response.data;
    if (!result.success) {
      alert("실패하였습니다. 관리자에게 문의해주세요.");
    }
  } catch (error) {
    alert("처리할 수 없습니다.");
    console.error(error);
  } finally {
    isLoading.value = false;
    await filterList();
  }
};
const deleteEmpContract = async (ct_idx: any) => {
  const isConfirmed = window.confirm("삭제하시겠습니까?");
  if (isConfirmed) {
    isLoading.value = true;
    try {
      const response = await axios.post(`/api/deleteEmpContract/${ct_idx}`);
      if (response) {
        await getYears();
        await filterList();
      } else {
        alert("삭제에 실패했습니다.");
      }
    } catch (error) {
      alert("처리할 수 없습니다.");
      console.error(error);
    } finally {
      isLoading.value = false;
    }
  }
};

const openBatchEditModal = () => {
  const checkedRows = empList.value.filter((row: Employee) => row.checked);
  
  if (checkedRows.length === 0) {
    alert("일괄 변경할 사원을 체크해주세요.");
    return;
  }
  
  // 초기화
  batchFields.value = [];
  batchEditType.value = 'absolute';
  batchEditValue.value = null;
  batchEditDialog.value = true;
};

const applyBatchEdit = async () => {
  if (batchFields.value.length === 0) {
    alert("변경할 항목을 선택해주세요.");
    return;
  }
  
  if (batchEditValue.value === null) {
    alert("변경할 값을 입력해주세요.");
    return;
  }
  
  const checkedRows = empList.value.filter((row: Employee) => row.checked);
  
  const isConfirmed = window.confirm(`체크한 ${checkedRows.length}명의 사원에 대해 일괄 변경을 적용하시겠습니까?`);
  if (!isConfirmed) return;
  
  isLoading.value = true;
  try {
    empList.value = empList.value.map((row: Employee) => {
      if (row.checked) {
        const updatedRow = { ...row } as Employee;
        
        batchFields.value.forEach(field => {
          if (field in updatedRow) {
            const fieldValue = nc(updatedRow[field as keyof Employee] as any) || 0;
            let newFieldValue = 0;
            
            switch (batchEditType.value) {
              case 'absolute':
                newFieldValue = Number(batchEditValue.value);
                break;
              case 'amount':
                newFieldValue = fieldValue + Number(batchEditValue.value);
                break;
            }
            
            (updatedRow as any)[field] = ac(newFieldValue);
          }
        });
        
        totalPay(updatedRow);
        
        return updatedRow;
      }
      return row;
    });
    
    batchEditDialog.value = false;
    
    const checkedEmployees = empList.value.filter((emp: Employee) => emp.checked).map((emp: any) => ({
      ...emp,
      ct_lunch_pay: nc(emp.ct_lunch_pay),
      ct_bojon_pay: nc(emp.ct_bojon_pay),
      ct_car_pay: nc(emp.ct_car_pay),
      ct_child_pay: nc(emp.ct_child_pay),
      ct_time_pay: nc(emp.ct_time_pay),
      ct_dang_pay: nc(emp.ct_dang_pay)
    }));
    
    const response = await axios.post("/api/saveEmpWageContract", {
      form: checkedEmployees,
    });
    const result = response.data;
    if (!result.success) {
      alert("실패하였습니다. 관리자에게 문의해주세요.");
    }
  } catch (error) {
    alert("처리할 수 없습니다.");
    console.error(error);
  } finally {
    isLoading.value = false;
    await filterList();
  }
};

onMounted(async () => {
  const currentDate = new Date();
  refYearMonth.value =
    currentDate.getFullYear() + "년 " + (currentDate.getMonth() + 1) + "월";
  await getYears();
  await filterList();
});

</script>

<style scoped>
.v-container .v-card:first-child {
  margin: 0 0 20px 0;
}

.empContractSheet {
  margin: 0 30px;
}

.empContractSheetTitle {
  width: 100%;
  border-bottom: 1px solid #333;
  padding: 0 0 5px 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.empContractSheetTitleMent {
  font-weight: 700;
  font-size: 22px;
  margin-right: 12px;
}

.empContractSheetTitle span {
  font-size: 16px;
  font-weight: 500;
}

.empContractSheetDate {
  font-size: 16px;
  padding: 3px 10px !important;
  background-color: #1325c6;
  border-radius: 5px;
  color: #fff;
  margin: 0 0 0px 5px;
}

.contractMainYearWrapper {
  display: flex;
  align-items: center;
  /* 세로 중앙 정렬 */
  gap: 16px;
  /* 두 요소 사이의 간격 */
  margin-bottom: 5px;
}

.contractMainYearWrapper input {
  text-align: right;
}

.contractMainYear {
  display: flex;
  flex-direction: column;
}

.workCalcTable_empContract,
.empListTable_empContract,
.wageCompareTable {
  border-collapse: collapse;
}

.workCalcTable_empContract tbody tr:hover,
.empListTable_empContract tbody tr:hover,
.wageCompareTable tbody tr:hover {
  background-color: #f0f0f0;
}

.workCalcTable_empContract th {
  background-color: #f5f0ff;
}

.workCalcTable_empContract th {
  padding: 5px 7px;
  border: 1px solid #bcbcbc;
}

.workCalcTable_empContract td {
  padding: 2px 6px;
  border: 1px solid #bcbcbc;
}

.empContractSumResultsTr {
  background-color: rgb(255, 251, 237);
}

.empContractAvgResultsTr {
  background-color: rgb(216, 238, 255);
  font-weight: 700;
}

.empListTable_empContract th,
.wageCompareTable th {
  background-color: #f5f0ff;
  padding: 5px 7px;
}

.empListTable_empContract th,
.empListTable_empContract td,
.wageCompareTable th,
.wageCompareTable td {
  border: 1px solid #bcbcbc;
}

.pd26 {
  padding: 2px 6px;
}
.empCtCheckTd{
  padding-top: 5px;
}
.empCtCheckTd input {
  transform: scale(1.7);
  /* 체크박스 크기 확대 */
}

.empListCtrlBtn_empContract .v-btn {
  margin: 3px 9px 5px 0;
  font-size: 15px;
  border-radius: 0;
  border: 1px solid #c0c0c0;
}

.empCtMoneyTd {
  text-align: right;
  padding: 2px 6px 2px 12px !important;
}

.empCtMoneyInputTd input {
  width: 85px;
  text-align: right;
  padding: 2px 3px !important;
}

.empCtDayInputTd input {
  width: 50px;
  text-align: center;
  padding: 2px 3px !important;
}

.empCtTimePayInputTd input {
  width: 60px;
  text-align: right;
  padding: 2px 3px !important;
}

.empCtMoneyInputTd input:focus,
.empCtDayInputTd input:focus,
.empCtTimePayInputTd input:focus {
  outline: none;
  background-color: rgb(216, 238, 255);
}

.empListTable_empContract thead tr:first-child th:nth-child(4),
.empListTable_empContract thead tr:nth-child(2) th:nth-child(4),
.empContractListTr td:nth-child(6),
.empListTable_empContract thead tr:first-child th:nth-child(5),
.empListTable_empContract thead tr:nth-child(2) th:nth-child(7),
.empContractListTr td:nth-child(9) {
  border-right: 1px solid #000 !important;
}

.empWageBasicTb thead tr:first-child th:nth-child(1),
.empWageBasicTb thead tr:first-child th:nth-child(2),
.empWageBasicTb thead tr:first-child th:nth-child(3),
.empWageBasicTb thead tr:first-child th:nth-child(4),
.empWageBasicTb thead tr:first-child th:nth-child(5),
.empWageBasicTb thead tr:first-child th:nth-child(6),
.empWageBasicTb thead tr:first-child th:nth-child(7),
.empWageBasicTb tbody tr td:nth-child(1),
.empWageBasicTb tbody tr td:nth-child(4),
.empWageBasicTb tbody tr td:nth-child(5),
.empWageBasicTb tbody tr td:nth-child(13),
.empWageBasicTb tbody tr td:nth-child(19),
.empWageBasicTb tbody tr td:nth-child(22),
.empWageBasicTb tbody tr td:nth-child(23) {
  border-right: 1px solid #d1d1d1;
}

.empWageBasicTb thead tr:last-child th:nth-child(3),
.empWageBasicTb thead tr:last-child th:nth-child(4),
.empWageBasicTb thead tr:last-child th:nth-child(12),
.empWageBasicTb thead tr:last-child th:nth-child(18),
.empWageBasicTb thead tr:last-child th:nth-child(21) {
  border-right: 1px solid #d1d1d1;
}

.empWageBasicTb thead tr {
  height: 38px !important;
  border-bottom: #000000 !important;
}

.empWageBasicTb th {
  color: #000;
  font-size: 13px !important;
  padding: 0 !important;
  background-color: #ffffff !important;
}

.empWageBasicTb td {
  font-size: 12px !important;
}

.empWageBasicTbTr th,
.empWageBasicTbTr td {
  padding: 0 4px 0 0 !important;
}

.empWageBasicTbTr:hover {
  background-color: #f0f0f0;
}

.empWageBasicTbTr td input {
  font-size: 12px !important;
  text-align: right;
  padding: 0 !important;
  min-height: 100% !important;
}

.v-field__input input {
  text-align: right !important;
}
</style>
